"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
const useStyles = () => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccTaskManagerScheduleStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      const flexDirection = 'column';
      const gap = isMobileView ? 0 : `0 ${pxToRem(12)}`;
      return {
        flexDirection,
        gap
      };
    };
    const ccTaskManagerSchedule = (0, _css.css)({
      marginBottom: pxToRem(30)
    });
    const ccTaskManagerScheduleGradeAndFeedback = (0, _css.css)({
      display: 'flex',
      flexWrap: 'nowrap',
      ...deviceProps()
    });
    return {
      ccTaskManagerSchedule,
      ccTaskManagerScheduleGradeAndFeedback
    };
  }, [isMobileView, pxToRem]);
  return {
    'cc-TaskManager__schedule': ccTaskManagerScheduleStyle.ccTaskManagerSchedule,
    'cc-TaskManager__schedule__grade-and-feedback': ccTaskManagerScheduleStyle.ccTaskManagerScheduleGradeAndFeedback
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;